const maxCouches = 32; // nombre de bits pour stocker les combinaison de couches
export const hexToArr = (n) => parseInt(n, 16).toString(2).padStart(maxCouches, '0').split('')
  .map((x) => x === '1')
  .reverse();

export const arrBoolToHex = (arrBool) => parseInt(arrBool.reverse()
  .map((x) => (x ? '1' : '0')).join('')
  .padStart(maxCouches, '0'), 2)
  .toString(16);
